class ContactFormManagement{

    constructor(){
        this.checkbox = document.getElementById("contact_choice_info_0");
        this.checkbox.addEventListener("click", () => this.manageClick());
    }

    manageClick() {
        if(this.checkbox.classList.contains("active")){
            this.checkbox.classList.remove("active");
        }else{
            this.checkbox.classList.add("active");
        }
    }
}